import {
  IData_UserSummary,
} from '../types/schema/user_summary'

import {
  featureHooks,
} from './hooks'

export const hasFeature = (
  summary: IData_UserSummary | null,
  feature: string,
  defaultValue: boolean,
): boolean => {
  if(!summary) return defaultValue
  const hook = featureHooks[summary.project_name]
  if(!hook) return defaultValue
  return hook(summary, feature, defaultValue)
}
